export const UX_icons = {
  Navigation: {
    isMaterialIcon: true,
    icon: 'explore',
  },
  Branding: {
    isMaterialIcon: true,
    icon: 'palette',
  },
  Checkout: {
    isMaterialIcon: true,
    icon: 'shopping_cart',
  },
  'Product Experience': {
    isMaterialIcon: true,
    icon: 'view_in_ar',
  },
  'Reviews & Social Proof': {
    isMaterialIcon: true,
    icon: 'reviews',
  },
  'Live Chat & Help': {
    isMaterialIcon: true,
    icon: 'mark_chat_unread',
  },
  'Recommendations & Personalization': {
    isMaterialIcon: true,
    icon: 'recommend',
  },
  performance: {
    isMaterialIcon: true,
    icon: 'bar_chart',
  },
  network: {
    isMaterialIcon: true,
    icon: 'api',
  },
  layout: {
    isMaterialIcon: true,
    icon: 'dashboard_2',
  },
  javascript: {
    isMaterialIcon: true,
    icon: 'code',
  },
  'Value Proposition': {
    isMaterialIcon: true,
    icon: 'attach_money',
  },
  'Primary CTA': {
    isMaterialIcon: true,
    icon: 'ads_click',
  },
  'Friction Before Action': {
    isMaterialIcon: true,
    icon: 'quiz',
  },
  'Trust Before Conversion': {
    isMaterialIcon: true,
    icon: 'verified',
  },
  'Commitment vs Page Intent': {
    isMaterialIcon: true,
    icon: 'checklist_rtl',
  },
  'Distraction & Leakage': {
    isMaterialIcon: true,
    icon: 'psychology_alt',
  },
};
